import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseCard',
  props: {
    type: {
      default: ""
    }
  },
  emits: ["click"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var cardTypeClass = computed(() => props.type === "news" ? "news-card" : props.type);
    var cardImgClass = computed(() => props.type ? "".concat(props.type, "-img") : "");
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["card", [cardTypeClass.value, _ctx.$attrs['class']]]),
        onClick: _cache[0] || (_cache[0] = $event => emits('click'))
      }, [_createElementVNode("div", {
        class: _normalizeClass(["card-img", [cardImgClass.value, _ctx.$attrs['card-img-classes']]])
      }, [_renderSlot(_ctx.$slots, "card-image")], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["card-body", [_ctx.$attrs['card-body-classes']]])
      }, [_renderSlot(_ctx.$slots, "card-description")], 2 /* CLASS */)], 2 /* CLASS */);
    };
  }
}));